module.exports = __webpack_public_path__ + "img/phone.5bf2de10.svg";